<mat-grid-list [cols]="4" gutterSize="25px" rowHeight="450px" class="grid-list-space">
    <mat-grid-tile class="align-items-inherit">
        <mat-card>
            <div class="display-style">
                <span class="label-wrapper">
                    <mat-label>Process Req Date:</mat-label>
                </span>
                <mat-form-field class="no-underline body-wrapper block-formfield">
                    <input matInput class="input-wrapper" [ngModel]="selectedTpr.pkReqDate | date:'M/d/y'" readonly
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('pkReqDate')" />
                </mat-form-field>
            </div>

            <div class="display-style">
                <span class=" label-wrapper">
                    Posted in eRed Book Site:
                </span>
                <mat-form-field class="block-formfield">
                    <input matInput class="input-wrapper" [matDatepicker]="firstUserReqDatepicker2"
                        [(ngModel)]="selectedTpr.pkApprDate"
                        (dateChange)="onGenericFieldChange('pkApprDate',selectedTpr.pkApprDate)"
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('pkApprDate')" />
                    <mat-datepicker-toggle matSuffix [for]="firstUserReqDatepicker2"></mat-datepicker-toggle>
                    <mat-datepicker #firstUserReqDatepicker2></mat-datepicker>
                </mat-form-field>
            </div>

            <custom-dropdown [data]="availOpts" label="GD & T:" [inline]="true" [value]="selectedTpr.gdAndTSel"
                valueField="designSource" textField="designSource"
                [disabled]="disabled || reSourced || inActive || !fieldAuthorized('gdAndTSel')"
                (selectionChange)="onGenericFieldChange('gdAndTSel',$event.value,selectedTpr)">
            </custom-dropdown>

            <custom-dropdown [data]="availOpts" label="Die Lineup:" [inline]="true" [value]="selectedTpr.pkWeldSel"
                valueField="designSource" textField="designSource"
                [disabled]="disabled || reSourced || inActive || !fieldAuthorized('pkWeldSel')"
                (selectionChange)="onGenericFieldChange('pkWeldSel',$event.value,selectedTpr)">
            </custom-dropdown>

            <custom-dropdown [data]="availOpts" label="Product Info:" [inline]="true"
                [value]="selectedTpr.pkProdInfoSel" valueField="designSource" textField="designSource"
                [disabled]="disabled || reSourced || inActive || !fieldAuthorized('pkProdInfoSel')"
                (selectionChange)="onGenericFieldChange('pkProdInfoSel',$event.value,selectedTpr)">
            </custom-dropdown>

            <custom-dropdown [data]="availOpts" label="Criteria Chk List:" [inline]="true"
                [value]="selectedTpr.pkCriteriaSel" valueField="designSource" textField="designSource"
                [disabled]="disabled || reSourced || inActive || !fieldAuthorized('pkCriteriaSel')"
                (selectionChange)="onGenericFieldChange('pkCriteriaSel',$event.value,selectedTpr)">
            </custom-dropdown>

            <custom-dropdown [data]="availOpts" label="Datum Matrix:" [inline]="true"
                [value]="selectedTpr.datumMatrixSel" valueField="designSource" textField="designSource"
                [disabled]="disabled || reSourced || inActive || !fieldAuthorized('datumMatrixSel')"
                (selectionChange)="onGenericFieldChange('datumMatrixSel',$event.value,selectedTpr)">
            </custom-dropdown>
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile class="align-items-inherit">
        <mat-card>
            <div style="margin-left: 25px;">
                <div>
                    <div class="checkbox-text">NEC</div>
                    <mat-checkbox class="checkbox-format checkbox" color="primary" [(ngModel)]="selectedTpr.eRdbk"
                        (ngModelChange)="onGenericFieldChange('erdbk',selectedTpr.eRdbk)"
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('erdbk')">
                    </mat-checkbox>
                </div>
                <div class="text-spacing"> </div>
                <div style="margin-top: -5px;">
                    <div class="checkbox-text">CERT</div>
                    <mat-checkbox class="checkbox-format checkbox" color="primary" [(ngModel)]="selectedTpr.eRdbkCert"
                        [disabled]="selectedTpr.eRdbkCertNA || disabled || reSourced || inActive || !fieldAuthorized('erdbkCert')"
                        (ngModelChange)="onGenericFieldChange('erdbkCert',selectedTpr.eRdbkCert)">
                    </mat-checkbox>
                    <div class="checkbox-text-space"> </div>
                    <mat-checkbox class="checkbox-format checkbox" color="primary" [(ngModel)]="selectedTpr.eRdbkCertNA"
                        [disabled]="selectedTpr.eRdbkCert || disabled || reSourced || inActive || !fieldAuthorized('eRdbkCertNA')"
                        (ngModelChange)="onGenericFieldChange('eRdbkCertNA',selectedTpr.eRdbkCertNA)"
                        labelPosition="after">
                        N/A
                    </mat-checkbox>
                </div>
                <div class="text-spacing"> </div>
                <div style="margin-top: -5px;">
                    <div class="checkbox-text">JES</div>
                    <mat-checkbox class="checkbox-format checkbox" color="primary" [(ngModel)]="selectedTpr.eRdbkOp"
                        (ngModelChange)="onGenericFieldChange('erdbkOp',selectedTpr.eRdbkOp)" disableRipple
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('erdbkOp')">
                    </mat-checkbox>
                </div>
                <div class="text-spacing"> </div>
                <div>
                    <div class="checkbox-text">R Study</div>
                    <mat-checkbox class="checkbox-format checkbox" color="primary" [(ngModel)]="selectedTpr.eRdbkCfs"
                        (ngModelChange)="onGenericFieldChange('erdbkCfs',selectedTpr.eRdbkCfs)"
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('erdbkCfs')">
                    </mat-checkbox>
                </div>
                <div class="text-spacing"> </div>
                <div>
                    <div class="checkbox-text">B/OFF Wksht Des</div>
                    <mat-checkbox class="checkbox-format checkbox" color="primary" [(ngModel)]="selectedTpr.eRdbkBo"
                        (ngModelChange)="onGenericFieldChange('erdbkBo',selectedTpr.eRdbkBo)" disableRipple
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('erdbkBo')">
                    </mat-checkbox>
                </div>
                <div class="text-spacing"> </div>
                <div>
                    <div class="checkbox-text">B/OFF Wksht Build</div>
                    <mat-checkbox class="checkbox-format checkbox" color="primary" [(ngModel)]="selectedTpr.eRdbkBob"
                        (ngModelChange)="onGenericFieldChange('erdbkBob',selectedTpr.eRdbkBob)" disableRipple
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('erdbkBob')">
                    </mat-checkbox>
                </div>
                <div class="text-spacing"> </div>
                <div>
                    <div class="checkbox-text">MSE QAB</div>
                    <mat-checkbox class="checkbox-format checkbox" color="primary" [(ngModel)]="selectedTpr.qabmse"
                        (ngModelChange)="onGenericFieldChange('qabmse',selectedTpr.qabmse)" disableRipple
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('qabmse')">
                    </mat-checkbox>
                </div>
                <div class="text-spacing"> </div>
                <div>
                    <div class="checkbox-text">DIE QAB</div>
                    <mat-checkbox class="checkbox-format checkbox" color="primary" [(ngModel)]="selectedTpr.qabdie"
                        (ngModelChange)="onGenericFieldChange('qabdie',selectedTpr.qabdie)" disableRipple
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('qabdie')">
                    </mat-checkbox>
                </div>
            </div>
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile class="align-items-inherit">
        <mat-card>
            <div class="display-style">
                <span class="label-wrapper">
                    <mat-label>JT Sent Sched:</mat-label>
                </span>
                <mat-form-field *ngIf="getTci()" class="no-underline body-wrapper block-formfield">
                    <input matInput class="input-wrapper" [ngModel]="selectedTpr.jTSentSched | date:'M/d/y'"
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('jtSentSched')" readonly />
                </mat-form-field>
                <mat-form-field *ngIf="!getTci()" class="no-underline body-wrapper block-formfield">
                    <input matInput class="input-wrapper" value="N/A" readonly
                        [disabled]="disabled || reSourced || inActive" />
                </mat-form-field>
            </div>

            <div class="display-style">
                <span class="label-wrapper">
                    <mat-label>JT Sent Actual:</mat-label>
                </span>
                <mat-form-field *ngIf="getTci()" class="block-formfield bg-green">
                    <input matInput class="input-wrapper" [matDatepicker]="firstUserReqDatepicker4"
                        [(ngModel)]="selectedTpr.jTSentAct"
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('jtSentAct')"
                        (dateChange)="onGenericFieldChange('jtSentAct',selectedTpr.jTSentAct)" />
                    <mat-datepicker-toggle matSuffix [for]="firstUserReqDatepicker4"></mat-datepicker-toggle>
                    <mat-datepicker #firstUserReqDatepicker4></mat-datepicker>
                </mat-form-field>
                <mat-form-field *ngIf="!getTci()" class="no-underline body-wrapper block-formfield">
                    <input matInput class="input-wrapper" value="N/A" readonly
                        [disabled]="disabled || reSourced || inActive" />
                </mat-form-field>
            </div>

            <div class="display-style">
                <span class="label-wrapper">
                    <mat-label>AVO Sched:</mat-label>
                </span>
                <mat-form-field *ngIf="getTci()" class="no-underline body-wrapper block-formfield">
                    <input matInput class="input-wrapper" [ngModel]="selectedTpr.avoSched | date:'M/d/y'"
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('avoSched')" readonly />
                </mat-form-field>
                <mat-form-field *ngIf="!getTci()" class="no-underline body-wrapper block-formfield">
                    <input matInput class="input-wrapper" value="N/A" readonly
                        [disabled]="disabled || reSourced || inActive" />
                </mat-form-field>
            </div>

            <div class="display-style">
                <span class="label-wrapper">
                    <mat-label>AVO Actual:</mat-label>
                </span>
                <mat-form-field *ngIf="getTci()" class="block-formfield bg-green">
                    <input matInput class="input-wrapper" [matDatepicker]="firstUserReqDatepicker6"
                        [(ngModel)]="selectedTpr.aVoAct"
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('avoAct')"
                        (dateChange)="onGenericFieldChange('aVoAct',selectedTpr.aVoAct)" />
                    <mat-datepicker-toggle matSuffix [for]="firstUserReqDatepicker6"></mat-datepicker-toggle>
                    <mat-datepicker #firstUserReqDatepicker6></mat-datepicker>
                </mat-form-field>
                <mat-form-field *ngIf="!getTci()" class="no-underline body-wrapper block-formfield">
                    <input matInput class="input-wrapper" value="N/A" readonly
                        [disabled]="disabled || reSourced || inActive" />
                </mat-form-field>
            </div>

            <div class="display-style">
                <span class="label-wrapper">
                    <mat-label>Model Review Sched:</mat-label>
                </span>
                <mat-form-field class="no-underline body-wrapper block-formfield">
                    <input matInput class="input-wrapper" [ngModel]="selectedTpr.mrRevSched | date:'M/d/y'"
                        (ngModel)="selectedTpr.mrRevSched" disabled readonly
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('mrRevSched')" />
                </mat-form-field>
            </div>

            <div class="display-style">
                <span class="label-wrapper">
                    <mat-label>Model Review Actual:</mat-label>
                </span>
                <mat-form-field class="block-formfield no-underline bg-green">
                    <input matInput class="input-wrapper" [matDatepicker]="firstUserReqDatepicker8"
                        [(ngModel)]="selectedTpr.mRRevAct"
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('mrRevAct')"
                        (dateChange)="onGenericFieldChange('mRRevAct',selectedTpr.mRRevAct)" />
                    <mat-datepicker-toggle matSuffix [for]="firstUserReqDatepicker8"></mat-datepicker-toggle>
                    <mat-datepicker class="bg-green" #firstUserReqDatepicker8></mat-datepicker>
                </mat-form-field>
            </div>
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile class="align-items-inherit">
        <mat-card>
            <div class="display-style">
                <span class="label-wrapper">
                    <mat-label>Math/JES Rev Sched:</mat-label>
                </span>
                <mat-form-field *ngIf="!getEtac()" class="no-underline body-wrapper block-formfield">
                    <input matInput class="input-wrapper" [ngModel]="selectedTpr.mathJesRevSched | date:'M/d/y'"
                        readonly
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('mathJesRevSched')" />
                </mat-form-field>
                <mat-form-field *ngIf="getEtac()" class="no-underline body-wrapper block-formfield">
                    <input matInput class="input-wrapper" value="N/A" readonly
                        [disabled]="disabled || reSourced || inActive" />
                </mat-form-field>
            </div>

            <div class="display-style">
                <span class="label-wrapper">
                    <mat-label>Math/JES Rev Actual:</mat-label>
                </span>
                <mat-form-field *ngIf="!getEtac()" class="block-formfield no-underline bg-green">
                    <input matInput class="input-wrapper" [matDatepicker]="firstUserReqDatepicker0"
                        [(ngModel)]="selectedTpr.mathJesRevAct"
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('mathJesRevAct')"
                        (dateChange)="onGenericFieldChange('mathJesRevAct',selectedTpr.mathJesRevAct)" />
                    <mat-datepicker-toggle matSuffix [for]="firstUserReqDatepicker0"></mat-datepicker-toggle>
                    <mat-datepicker class="bg-green" #firstUserReqDatepicker0></mat-datepicker>
                </mat-form-field>
                <mat-form-field *ngIf="getEtac()" class="no-underline body-wrapper block-formfield">
                    <input matInput class="input-wrapper" value="N/A" readonly
                        [disabled]="disabled || reSourced || inActive" />
                </mat-form-field>
            </div>

            <div class="display-style">
                <span class="label-wrapper">
                    <mat-label *ngIf="!getEtac()">Product Part Chg Lvl:</mat-label>
                </span>
                <mat-form-field *ngIf="!getEtac()" class="no-underline body-wrapper block-formfield">
                    <input matInput class="input-wrapper" [(ngModel)]="selectedTpr.productChgLvl" readonly
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('productChgLvl')" />
                </mat-form-field>
            </div>

            <div class="display-style">
                <span class="label-wrapper">
                    <mat-label *ngIf="!getEtac()">GD & T Part Chg Lvl:</mat-label>
                </span>
                <mat-form-field *ngIf="!getEtac()" class="no-underline body-wrapper block-formfield">
                    <input matInput class="input-wrapper" [(ngModel)]="selectedTpr.gdtChgLvl" readonly
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('gdtChgLvl')" />
                </mat-form-field>
            </div>
        </mat-card>
    </mat-grid-tile>
</mat-grid-list>
